import React from 'react'
import ReactDOM from 'react-dom'
import 'normalize.css/normalize.css';
import './styles/css/styles.css'
import App from './components/App'

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js